import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export const CountTable = ({
  data,
  label,
  showHours = false,
  autoHeight = false,
}) => (
  <TableContainer
    component={Paper}
    sx={{
      maxHeight: autoHeight ? "auto" : 120,
      overflowY: autoHeight ? "visible" : "auto",
      mt: 1,
    }}
  >
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: "bold" }}>{label}</TableCell>
          <TableCell
            sx={{
              fontWeight: "bold",
              width: 100,
            }}
          >
            {showHours ? "Hours" : "Count"}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(data).length === 0 ? (
          <TableRow>
            <TableCell colSpan={2} align="center">
              No data
            </TableCell>
          </TableRow>
        ) : (
          Object.entries(data).map(([key, count]) => (
            <TableRow key={key}>
              <TableCell>{key}</TableCell>
              <TableCell>{count}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </TableContainer>
);
